export default __webpack_public_path__ + "static/media/logoColor.a5f10388.png";